import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './contexts/AuthContext'; // Ya no importamos useAuth aquí
import { ThemeProvider } from './contexts/ThemeContext';
import PrivateLayout from './routes/PrivateLayout';
import NotFoundPage from './common/UI/NotFound/NotFound';
import Unauthorized from './auth/Unauthorized';
import Users from './modules/systemAdmin/pages/Users';
import Roles from './modules/systemAdmin/pages/Roles';
import CPermissionRoles from './modules/systemAdmin/pages/Roles/PermissionRoles';
import LoginPage from './auth/Login';
import TiglobalPage from './auth/GovCo';
import DashboardPage from './modules/systemAdmin/pages/Dashboard';
import WidgetsPage from './modules/systemAdmin/pages/Widgets';
import ProtectedRoute from './routes/ProtectedRoute';
import ReportTotalQueriesPage from './modules/systemAdmin/pages/Reports/ReportTotalQueries';
import ReportSuccessRatePage from './modules/systemAdmin/pages/Reports/ReportSuccessRate';
import ReportSResponseTimePage from './modules/systemAdmin/pages/Reports/ReportResponseTime';
import ReportSIrrelevantResponseRatePage from './modules/systemAdmin/pages/Reports/ReportIrrelevantResponseRate';
import ReportSSatisfactionLevelPage from './modules/systemAdmin/pages/Reports/ReportsatisfactionLevel';
import ReportAbandonmentRatePage from './modules/systemAdmin/pages/Reports/AbandonmentRate';
import ReportInquiryFrequencybyProcedurePage from './modules/systemAdmin/pages/Reports/InquiryFrequencybyProcedure';
import ReportMostUsedChannelsPage from './modules/systemAdmin/pages/Reports/MostUsedChannels';
import EnvironmentPage from './modules/systemAdmin/pages/Environment';
import InstitutionsPage from './modules/systemAdmin/pages/Institutions';
import ProceduresPage from './modules/systemAdmin/pages/Procedures';
import ComunicationsChannelsPage from './modules/systemAdmin/pages/ComunicationsChannels';
// Ya no necesitamos importar TokenRefreshModal aquí, lo hace AuthProvider

console.log('version 1.0.1');

const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
  return null;
};

const App: React.FC = () => {
  const tokenFromCookie = getCookie('authToken') ?? '';
  return (
    <Router>
      <AuthProvider tokenFromCookie={tokenFromCookie}>
        {/* El ToastContainer y el resto de la aplicación permanecen aquí */}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          toastClassName={'Toastify__toast'}
        />
        <ThemeProvider>
          <Routes>
            {/* <Route path='/' element={<ChatBotPage />} /> */}
            <Route path="/widget-test" element={<TiglobalPage />} />
            <Route path="/" element={<LoginPage />} />
            <Route path="/login" element={<LoginPage />} />
            {/* Nueva ruta protegida con un rol diferente */}
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <PrivateLayout>
                    <DashboardPage />
                  </PrivateLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/adminUsers/roles"
              element={
                <ProtectedRoute>
                  <PrivateLayout>
                    <Roles />
                  </PrivateLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/adminUsers/roles/:roleId/permissions/:name?"
              element={
                <ProtectedRoute>
                  <PrivateLayout>
                    <CPermissionRoles />
                  </PrivateLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/adminUsers/users"
              element={
                <PrivateLayout>
                  <Users />
                </PrivateLayout>
              }
            />
            <Route
              path="/admin/widgets"
              element={
                <PrivateLayout>
                  <WidgetsPage />
                </PrivateLayout>
              }
            />
            <Route
              path="/report/report-total-queries"
              element={
                <ProtectedRoute>
                  <PrivateLayout>
                    <ReportTotalQueriesPage />
                  </PrivateLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/report/report-success-rate"
              element={
                <ProtectedRoute>
                  <PrivateLayout>
                    <ReportSuccessRatePage />
                  </PrivateLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/report/report-response-time"
              element={
                <ProtectedRoute>
                  <PrivateLayout>
                    <ReportSResponseTimePage />
                  </PrivateLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/report/report-satisfaction"
              element={
                <ProtectedRoute>
                  <PrivateLayout>
                    <ReportSSatisfactionLevelPage />
                  </PrivateLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/report/report-channels"
              element={
                <ProtectedRoute>
                  <PrivateLayout>
                    <ReportMostUsedChannelsPage />
                  </PrivateLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/report/report-query-frequency"
              element={
                <ProtectedRoute>
                  <PrivateLayout>
                    <ReportInquiryFrequencybyProcedurePage />
                  </PrivateLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/report/report-abandonment-rate"
              element={
                <ProtectedRoute>
                  <PrivateLayout>
                    <ReportAbandonmentRatePage />
                  </PrivateLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/report/irrelevant-response-rate"
              element={
                <ProtectedRoute>
                  <PrivateLayout>
                    <ReportSIrrelevantResponseRatePage />
                  </PrivateLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/environment"
              element={
                <PrivateLayout>
                  <EnvironmentPage />
                </PrivateLayout>
              }
            />
            <Route
              path="/admin/institutions"
              element={
                <PrivateLayout>
                  <InstitutionsPage />
                </PrivateLayout>
              }
            />
            <Route
              path="/admin/procedures"
              element={
                <PrivateLayout>
                  <ProceduresPage />
                </PrivateLayout>
              }
            />
            <Route
              path="/admin/comunicationsChannels"
              element={
                <PrivateLayout>
                  <ComunicationsChannelsPage />
                </PrivateLayout>
              }
            />
            <Route path="/not-authorized/:login?" element={<Unauthorized />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </ThemeProvider>
        {/* El TokenRefreshModal se renderiza ahora dentro de AuthProvider,
            por lo que no necesita ser colocado aquí directamente. */}
      </AuthProvider>
    </Router>
  );
};

export default App;
